module.exports = __webpack_public_path__ + "static/media/KaTeX_Typewriter-Regular.ba01f72a.woff";